import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'proforma-template-library.common.utils.form-selected-failed-flag.title',
		defaultMessage: "We couldn't open this form template. Select template to try again.",
		description: 'Title for the flag that appears when a form template fails to open',
	},
});
